import { render, staticRenderFns } from "./approval-button-simple.vue?vue&type=template&id=a9a6125e&scoped=true"
import script from "./approval-button-simple.vue?vue&type=script&lang=js"
export * from "./approval-button-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a6125e",
  null
  
)

export default component.exports